import type { FC } from 'react'

import type { Locale } from '@skytech/types'

import { useFormattedNumber } from '@/hooks/use-formatted-number'

export const FormattedNumber: FC<{
  amount: number
  locale?: Locale
  precision?: number
  className?: string
}> = ({ amount, locale, precision, className }) => {
  const { formatNumber } = useFormattedNumber()
  return (
    <span className={className}>
      {formatNumber({
        amount,
        locale,
        precision,
      })}
    </span>
  )
}
